// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1k3H7","content":"Consent_content__2wnnP","footer":"Consent_footer__xObOO"};